export interface ApiClientOptions {
  baseUrl: string;
}

export class ApiClient {
  private readonly baseUrl: string;

  constructor(options: ApiClientOptions) {
    this.baseUrl = options.baseUrl.replace(/\/+$/, '');
  }

  async get<T>(path: string): Promise<T> {
    const response = await fetch(`${this.baseUrl}${path}`, {
      method: 'GET',
      headers: {
        accept: 'application/json'
      }
    });

    return this.handleResponse<T>(response);
  }

async post<T>(path: string, body?: unknown): Promise<T> {
  const hasBody = body !== undefined;

  const response = await fetch(`${this.baseUrl}${path}`, {
    method: 'POST',
    headers: hasBody
      ? {
          'content-type': 'application/json',
          accept: 'application/json'
        }
      : {
          accept: 'application/json'
        },
    body: hasBody ? JSON.stringify(body) : undefined
  });

  return this.handleResponse<T>(response);
}

  private async handleResponse<T>(response: Response): Promise<T> {
    const contentType = response.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const payload = isJson ? await response.json() : await response.text();

    if (!response.ok) {
      const message =
        typeof payload === 'object' && payload !== null && 'message' in payload
          ? String((payload as { message: unknown }).message)
          : `Request failed with status ${response.status}`;

      throw new Error(message);
    }

    return payload as T;
  }
}